<template>
  <div>
    <div style=" margin-left: 12px;">
      <span style="color: #53BACA; font-size: 11px; font-weight: 500;">Información General</span>
      <b-row class="mt-3">
        <b-col>
          <span class="textForm">Nombre del laboratorio <span style="color: red">*</span></span>
          <b-form-input
              class="tamanioCampo"
              placeholder="Ingresa el nombre del laboratorio"
              v-model="infoGeneral.nombreLab"
              type="text"
              :state=" infoGeneral.nombreLab != null && infoGeneral.nombreLab !== '' "
              required
          ></b-form-input>
          <br/>
          <span class="textForm">Código postal <span style="color: red">*</span></span>
          <b-form-input
              class="tamanioCampo"
              placeholder="Ingresa el código postal"
              v-model="infoGeneral.codigoPost"
              type="number"
              :state="infoGeneral.codigoPost != null && infoGeneral.codigoPost.length === 5"
              required
              maxlength="5"
              @keydown="filterJustNumber($event)"
          ></b-form-input>
          <br/>
          <span class="textForm">Estado <span style="color: red">*</span></span>
          <v-select
              id="idEstado"
              label="nombreEstado"
              v-model="infoGeneral.idEstado"
              :options="listaEstados"
              required
              placeholder="Selecciona el estado"
              :reduce="(variable) => variable.idEstado"
          >
            <span slot="no-options">No hay valores disponibles</span>
          </v-select>
          <br/>
          <b-form-checkbox
              id="checkbox-1"
              v-model="infoGeneral.flujoDigital"
          >
            <span class="textForm">¿Cuenta con flujo digital? </span>
          </b-form-checkbox>
          <br/>
          <span class="textForm">Colorimetros </span>
          <v-select
              v-model="infoGeneral.colorimetros"
              placeholder="Selecciona uno o más colorimetros"
              id="idColorimetro"
              label="nombre"
              required
              :reduce="(variable) => variable.idColorimetro"
              :options="listaColorimetros"
              multiple
          >
            <span slot="no-options">No hay valores disponibles</span>
          </v-select>
        </b-col>

        <b-col>
          <span class="textForm">Dirección<span style="color: red">*</span></span>
          <b-form-input
              class="tamanioCampo"
              placeholder="Ingresa la dirección"
              v-model="infoGeneral.direccion"
              type="text"
              :state="infoGeneral.direccion != null && infoGeneral.direccion !== '' "
              required
          ></b-form-input>
          <br/>
          <span class="textForm">Ciudad<span style="color: red">*</span></span>
          <b-form-input
              class="tamanioCampo"
              placeholder="Ingresa la ciudad"
              v-model="infoGeneral.ciudad"
              type="text"
              :state="infoGeneral.ciudad != null && infoGeneral.ciudad !== '' "
              required
          ></b-form-input>
          <br/>
          <span class="textForm">Días de atención <span style="color: red">*</span></span>
          <div style="border: 1px solid #d2d4d5; border-radius: 6px; height: 40px; width: 394px">
            <div style="  display: flex; margin-left: 0px; margin-top: 12px;   ">
              <div class="text-center" v-for="(day, index) in days" :key="index"
                   style=" cursor: pointer; margin-top: -13px; height: 41px; width: 56px; "
                   @click="toggleSelection(day.id)"
                   :class="{
                            'border-blue-500 text-blue-500': infoGeneral.diasSeleccionados.includes(day.id) ,
                            'text-gray-400': !infoGeneral.diasSeleccionados.includes(day.id)
                            }"
              >
                <div style="margin-top: 8px;">
                  <span style="font-size: 11px;" >  {{ day.nombre }}   </span>
                </div>
              </div>
            </div>
          </div>
          <br/>
          <span class="textForm">Tipo de flujo físico <span style="color: red"> *</span> </span>
          <v-select
              id="idTipoFlujoFisico"
              label="nombre"
              v-model="infoGeneral.tipoFlujoFisico"
              :options="listaTipoFlujoFisico"
              required
              multiple
              placeholder="Selecciona el tipo de flujo"
              :reduce="(variable) => variable.idTipoFlujoFisico"
          >
            <span slot="no-options">No hay valores disponibles</span>
          </v-select>
        </b-col>
    </b-row>
    </div>

    <div class="text-center mt-4">
      <b-button variant="outline-primary" pill size="sm"
                @click="guardarInfoGeneral()"
                :disabled=" guardando || (infoGeneral.ciudad == null || infoGeneral.ciudad === '' )
                || (infoGeneral.nombreLab == null || infoGeneral.nombreLab === '')
                || (infoGeneral.codigoPost == null || infoGeneral.codigoPost.length > 5 || infoGeneral.codigoPost.length <5)
                || (infoGeneral.idEstado == null )
                || (infoGeneral.diasSeleccionados.length === 0)

                || (infoGeneral.tipoFlujoFisico != null && infoGeneral.tipoFlujoFisico.length === 0 )
                 || (infoGeneral.direccion == null || infoGeneral.direccion === '')"
      >
        <span>Guardar</span>
<!-- || (infoGeneral.colorimetros.length === 0)       -->
        <b-spinner v-if="guardando" variant="info" small/>
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "InformacionGeneralLab",
  components: {},
  props: {
    listaTipoFlujoFisico: Array,
    listaEstados: Array,
    informacionGeneral: Object,
    editar: Boolean,
    idLaboratorio: Number,
    listaColorimetros: Array,
  },
  data: () => ({
    infoGeneral: {
      idLaboratorio: null,
      nombreLab: null,
      codigoPost: null,
      idEstado: null,
      flujoDigital: false,
      colorimetros:[],
      direccion: null,
      ciudad: null,
      tipoFlujoFisico: [],
      diasSeleccionados:[],
    },
    days: [
      {id: 1, nombre: "Lun."  },
      {id: 2, nombre: "Mar."  },
      {id: 3, nombre: "Miérc."  },
      {id: 4, nombre: "Juev."  },
      {id: 5, nombre: "Vier."  },
      {id: 6, nombre: "Sáb."  },
      {id: 7, nombre: "Dom."  },
    ],
    guardando: false,
  }),
  whatch: {

  },
  created() {
    if (this.editar){
      this.infoGeneral = JSON.parse(JSON.stringify(this.informacionGeneral))
    }
  },
  methods: {

    toggleSelection(index) {
      if (this.infoGeneral.diasSeleccionados.includes(index)) {
        this.infoGeneral.diasSeleccionados = this.infoGeneral.diasSeleccionados.filter(i => i !== index);
      } else {
        this.infoGeneral.diasSeleccionados.push(index);
      }

    },
    guardarInfoGeneral(){
     /* const guardar = {
        nombreLab : this.nombreLab,
        codigoPost : this.codigoPost,
        estado : this.estado,
        flujoDigital : this.flujoDigital,
        colorimetros : this.colorimetros,
        direccion : this.direccion,
        ciudad : this.ciudad,
        tipoFlujoFisico : this.tipoFlujoFisico,
        diasSeleccionados : this.diasSeleccionados,
      }*/
      if (this.guardando){
        return;
      }
      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.guardando = true;
          this.$http.post(this.$api + "labs/guardar/infoGeneralLabs", this.infoGeneral)
              .then((resp) => {
                if (resp.data.data) {
                  this.idLaboratorio = resp.data.data.idLaboratorio
                  this.$swal({
                    icon: "success",
                    text: "Se guardó la información general del laboratorio  correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                    onClose: () => {
                      console.log("emit ..")
                      this.$emit('obtenerLaboratorios', 1, this.idLaboratorio);
                    }
                  })
                }
                this.guardando = false;
              })
        }
      })

    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '+'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },
  }
}
</script>

<style scoped>
.textForm {
  font-size: 10px;
}
.tamanioCampo {
  width: 94%;
}
.border {
  border: 1px solid #004A98;
}
.border-blue-500 {
  color: #004A98;
  font-weight: 600;
  border: 1px solid #004A98;
  border-radius: 6px;

}
</style>